import React, { Context, createContext, PropsWithChildren, useCallback, useContext, useEffect, useState } from 'react'
import { callApi, TApiResponse } from '../api'
import { TBrand, IBrand, TBrandActions } from '../types'
import { currentBrand as hostBrand } from '../../config'

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

const initialBrandState: IBrand = {
	currentBrand: null,
	loading: false,
}

const BrandContext: Context<{
	brand: IBrand
	actions: TBrandActions
}> = createContext({
	brand: initialBrandState,
	actions: {
		getCurrentBrand: () => {},
	},
})

export const BrandProvider = (props: PropsWithChildren<{}>) => {
	const [loading, setLoading] = useState<boolean>(false)
	const [error, setProviderError] = useState<string | null>(null)
	const [currentBrand, setCurrentBrand] = useState<TBrand>(null)

	const fetchCurrentBrand = async () => {
		setLoading(true)
		const brandResponse: TApiResponse = await callApi('/brand', {})

		const { data } = brandResponse.payload

		if (brandResponse.ok) {
			setLoading(false)
			setProviderError(null)
			setCurrentBrand(data.brand)
		} else {
			setLoading(false)
			setProviderError(data.message || 'Cannot get Current Brand!')
		}
	}

	const getCurrentBrand = useCallback(fetchCurrentBrand, [])

	useEffect(() => actions.getCurrentBrand(), [])

	const actions: TBrandActions = { getCurrentBrand }
	const title = currentBrand?.name ?? hostBrand.title

	return (
		<BrandContext.Provider value={{ brand: { currentBrand, loading, error }, actions }}>
			{props.children}
		</BrandContext.Provider>
	)
}

export const useBrandContext: () => {
	brand: IBrand
	actions: TBrandActions
} = () => {
	return useContext(BrandContext)
}
